import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AppSettingsService } from '@woolworthsnz/styleguide';
import { AppService } from '../services/app.service';

const LOGIN_PAGE_URL = '/shop/securelogin';
@Injectable({
	providedIn: 'root',
})
export class IframeNavigationGuard {
	constructor(
		private appSettingsService: AppSettingsService,
		private appService: AppService,
		private router: Router
	) {}

	isLoginPage(url: string): boolean {
		return url.startsWith(LOGIN_PAGE_URL);
	}

	private isAuxiliaryRouteUrl(url: string): boolean {
		return !!url && url.includes('(');
	}

	canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		const isInitialNavigation = this.router.getCurrentNavigation()?.id === 1;
		const isLoginPage = this.isLoginPage(state.url);
		const isAuxiliaryRoute = this.isAuxiliaryRouteUrl(state.url);
		const isExternalRoute = !!route.data?.['iframeExternal'];
		if (this.appSettingsService.isIframeMode()) {
			if (!isLoginPage && !isInitialNavigation && !isAuxiliaryRoute) {
				this.appService.sendMessageToParent('NAVIGATE', { url: state.url, historyPushOnly: !isExternalRoute });
				if (isExternalRoute) {
					return false;
				}
			}
		}
		return true;
	}
}
